import { clearToken } from "../../shared/auth";
import { httpBackend } from "../../shared/httpClient";

declare const toastr: any;

export function initNavLogout(): void {
    //usa delegation così funziona anche se nav viene renderizzata dinamicamente
    $(document).on("click", "[data-action='logout']", async (e) => {
        e.preventDefault();

        try {
            //chiude cookie auth sul progetto WEB
            await httpBackend.post("/auth/signout", {});
        } catch {
            // anche se fallisce, proseguo (es. magari abbiamo la session già scaduta)
        } finally {
            clearToken();
            window.location.href = "/login";
        }
    });
}

export const initNavigation = (): void => {
    const $sidebarMenu = $("#sidebarMenu");

    // 1. Recupero degli ID dai data-attributes (quelli che Razor popola)
    const activeItemSelector = $sidebarMenu.attr("active-item");
    const activeSubItemSelector = $sidebarMenu.attr("active-sub-item");

    // 2. Reset dello stato precedente (pulizia)
    $sidebarMenu.find(".nav-item").removeClass("active");

    // 3. Attivazione dell'item principale
    if (activeItemSelector) {
        const $activeItem = $(activeItemSelector);
        if ($activeItem.length > 0) {
            $activeItem.addClass("active");

            // Se l'item è dentro un collassabile, lo apriamo
            const $parentCollapse = $activeItem.closest(".collapse");
            if ($parentCollapse.length > 0) {
                ($parentCollapse as any).collapse('show');
            }
        }
    }

    // 4. Attivazione del sub-item (se presente)
    if (activeSubItemSelector) {
        $(activeSubItemSelector).addClass("active");
    }
};